import { Component, OnInit, EventEmitter, Inject } from "@angular/core";
import {
  MatDialogRef,
  MatDialog,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { AdminService } from "src/app/pages/admin/admin-service";
import { roles } from "../../../../../admin/role-querry";

@Component({
  selector: "app-role-dialog",
  templateUrl: "./role-dialog.component.html",
  styleUrls: ["./role-dialog.component.scss"],
})
export class RoleDialogComponent implements OnInit {
  saveRolesFunction = new EventEmitter();

  roleIds: any = [];
  payload: any = {};
  constructor(
    public dialogRef: MatDialogRef<RoleDialogComponent>,
    public dialog: MatDialog,
    public roleApi: AdminService,
    @Inject(MAT_DIALOG_DATA) public formData
  ) {}

  ngOnInit(): void {}
  get title() {
    if (this.formData.roles && this.formData.roles.length > 0) {
      return "Update";
    } else {
      return "Add";
    }
  }

  save() {
    this.saveRolesFunction.emit(this.payload);
    this.closeDialog();
  }
  closeDialog() {
    this.dialogRef.close();
    this.formData = {};
  }

  assignRoles(data, event) {
    const params = {
      id: data.id,
    };

    if (event.checked === true) {
      this.formData.roles.push(params);
    }
    if (this.formData.roles.length > 0) {
      const el = this.formData.roles.find((entry) => entry.id === data.id);

      const index = this.formData.roles.findIndex(
        (entry) => entry.id === data.id
      );

      if (el && event.checked === false) {
        this.formData.roles.splice(index, 1);
      }
    }
    this.payload.revokeRole = true;
    this.payload.roleIds = this.formData.roles.map((r) => r.id);
    this.payload.id = this.formData.id;
  }

  getRoles(data) {
    this.payload.revokeRole = true;
    this.payload.roleIds = data.map((r) => r.id);
    this.payload.id = this.formData.id;
  }
}
